import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  List,
  TextField,
  Tooltip,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

import ItemListaSegurados from "./ItemListaSegurados";
import ModalExclusao from "../../Components/ModalExclusao";

import { excluirSegurado, listarTodosSegurados } from "../../Store/Actions/API/seguradosActions";
import { setUltimoUpdateListaSegurados } from "../../Store/Actions/Reducer/menuActions";
import { setLoadingGeral } from "../../Store/Actions/Reducer/mainActions";
import { formataCpf } from "../../Utils/utils";

export default function ListaSegurados() {

  const dispatch = useDispatch();
  const history = useHistory();

  const [todosSegurados, setTodosSegurados] = useState([]);
  const [segurados, setSegurados] = useState([]);
  const [filtroSegurados, setFiltroSegurados] = useState("");

  const [seguradoExcluir, setSeguradoExcluir] = useState(null);
  const [openModalExclusao, setOpenModalExclusao] = useState(false);
  const [loadingExcluir, setLoadingExcluir] = useState(false);

  const [bloquearExclusao, setBloquearExclusao] = useState(false);

  const { ultimoUpdateListaSegurados } = useSelector((state) => state.menu);

  useEffect(() => {
    if (!filtroSegurados) setSegurados(todosSegurados);
    else filtrarSegurados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroSegurados]);

  useEffect(() => {
    buscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ultimoUpdateListaSegurados]);

  const buscar = async () => {
    dispatch(setLoadingGeral(true, "Carregando segurados..."));

    const retorno = await listarTodosSegurados();

    dispatch(setLoadingGeral(false));

    if (retorno !== null) {
      setSegurados(retorno.segurados ?? retorno);
      setTodosSegurados(retorno.segurados ?? retorno);
      setBloquearExclusao(retorno.bloquearExclusao ?? false);
    }
  }

  const filtrarSegurados = () => {
    const possuiFiltro = !!filtroSegurados;
    if (!possuiFiltro) {
      setSegurados(todosSegurados);
      return;
    }

    const seguradosFiltrados = todosSegurados
      .filter(
        (x) =>
          x.cpf.toLowerCase().includes(filtroSegurados.trim().toLowerCase()) ||
          x.nome.toLowerCase().includes(filtroSegurados.trim().toLowerCase()) ||
          formataCpf(x.cpf).toLowerCase().includes(filtroSegurados.trim().toLowerCase())
      );

    setSegurados(seguradosFiltrados);
  }

  const openModalExcluirSegurado = (segurado) => {
    setSeguradoExcluir(segurado);
    setOpenModalExclusao(true);
  }

  const confirmaExcluir = async () => {
    setLoadingExcluir(true);
    const response = await excluirSegurado(seguradoExcluir.cpf);
    setLoadingExcluir(false);

    if (response.sucesso) {
      setSeguradoExcluir(null);
      setOpenModalExclusao(false);
      dispatch(setUltimoUpdateListaSegurados());
      history.push('/home');
    }
  }

  const cancelaExcluir = () => {
    setSeguradoExcluir(null);
    setOpenModalExclusao(false);
  }

  return (
    <div>
      {(openModalExclusao && seguradoExcluir !== null) && <ModalExclusao
        open={openModalExclusao}
        titulo={'Excluir Segurado'}
        onConfirma={confirmaExcluir}
        loading={loadingExcluir}
        onCancela={cancelaExcluir}
        textoComponent={<span>
          Tem certeza que você deseja excluir o segurado
          <b>{" " + formataCpf(seguradoExcluir.cpf)} - {seguradoExcluir.nome}</b>?{" "}
          Todos os registros serão apagados e não será possível resgatá-los
          novamente.
        </span>}
      />}
      <TextField
        id="outlined-basic"
        label="Filtrar segurados"
        variant="outlined"
        style={{
          width: "300px",
          marginLeft: "20px",
          marginTop: "20px",
        }}
        InputProps={{
          endAdornment: (
            <Tooltip title="Limpar filtro">
              <IconButton onClick={() => setFiltroSegurados("")}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          ),
        }}
        disabled={(todosSegurados.length === 0)}
        value={filtroSegurados}
        onChange={(e) => setFiltroSegurados(e.target.value)}
      />

      {segurados.length > 0 ? (
        <List style={{ height: `calc(100vh - ${(history.location.state && history.location.state.cpf) ? '370px' : '322px'})`, overflowY: "auto", marginTop: 12 }}>
          {segurados.map((seg, ind) => (
            <ItemListaSegurados
              key={ind}
              segurado={seg}
              bloquearExclusao={bloquearExclusao}
              openExclusao={() => openModalExcluirSegurado(seg)}
            />
          ))}
        </List>
      ) : (
        <Typography
          style={{
            textAlign: "center",
            verticalAlign: "center",
            marginTop: "50%",
            position: "relative",
          }}
        >
          Sem segurados cadastrados
        </Typography>
      )}
    </div>
  );
}
